import { Component, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { ActivatedRoute, Router } from '@angular/router';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { ScreenSettingsService } from '@services/screen-settings/screen-settings.service';
import { ScreenService } from '@services/screens/screen.service';
import { AngieScreensService } from '@services/angie-screens/angie-screens.service';

@Component({
    selector: 'app-screen-detail',
    templateUrl: './screen-settings.component.html',
    styleUrls: ['./screen-settings.component.scss'],
    providers: [ScreenSettingsService, ScreenService, AngieScreensService],
    standalone: false
})
export class ScreenSettingsComponent implements OnInit {

  public params: any;

  public pageActions: PageAction[];

  public screenSettings: Models.LegacyScreenSetting;
  public screen: any;
  public screenPath = 'screens';
  public title;

  public isLoading = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private screenSettingsService: ScreenSettingsService,
    private screenService: ScreenService,
    private angieScreensService: AngieScreensService,
  ) {
  }

  ngOnInit() {
    this.createPageActions();
    this.isLoading = true;
    this.screenSettingsService.find(0, 1, { screenUuid: this.route.snapshot.params['id'] }).then(response => {
      this.screenSettings = response.data[0];
      this.fetchScreen(this.route.snapshot.params['id']).then(() => {
        this.title = this.screen.name;
      });
      this.isLoading = false;
    });
  }

  fetchScreen(uuid) {
    return this.screenService.find(0, 1, { uuid: uuid }).then(screen => {
      if (!screen || !screen.data || !screen.data.length) {
        return this.angieScreensService.find(0, 1, { uuid: uuid }).then(angieScreen => {
          this.screenPath = 'angie-screens';
          this.screen = angieScreen.data && angieScreen.data.length ? angieScreen.data[0] : null;
        });
      }
      this.screen = screen.data[0];
    });
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'desktop_windows',
        title: 'Overview Screen',
        callback: () => {
          this.router.navigate([this.screenPath, this.screen._id]);
        }
      }),
      new PageAction({
        icon: 'edit',
        title: 'Edit Screen Settings',
        callback: () => {
          this.router.navigate(['screen-settings', this.route.snapshot.params['id'], 'edit']);
        }
      })
    ];
  }
}
